var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"row"},[_c('Logo_ACU',{staticClass:"col-md-2"}),_c('Logo_IMA',{staticClass:"col-md-2 mt-1"})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }